export const menu = [
  {
    id: "panel",
    screenToShow: "panel",
    text: "Inicio",
    icon: "../../images/menu-home.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [],
  },
  {
    id: "patient-search",
    screenToShow: "patient-search",
    text: "Pacientes",
    icon: "../../images/patient-icon.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [
      {
        id: "patient-datos",
        screenToShow: "patient-datos",
        text: "Datos",
        icon: "../../images/submenu.svg",
        plusScreen: "patient-datos-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
      {
        id: "patient-compras",
        screenToShow: "patient-datos",
        text: "Compras",
        icon: "../../images/menu-shopping-bag.svg",
        plusScreen: "patient-compras-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
      {
        id: "patient-optometria",
        screenToShow: "patient-datos",
        text: "Optometría",
        icon: "../../images/menu-multiestenope.svg",
        plusScreen: "patient-optometria-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
      {
        id: "patient-gafas",
        screenToShow: "patient-datos",
        text: "Gafas",
        icon: "../../images/menu-gafas.svg",
        plusScreen: "patient-gafas-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
      {
        id: "patient-lentes-contacto",
        screenToShow: "patient-datos",
        text: "Lentes de contacto",
        icon: "../../images/menu-lentillas.svg",
        plusScreen: "patient-lentes-contacto-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
      {
        id: "patient-audiometria",
        screenToShow: "patient-datos",
        text: "Audiometría",
        icon: "../../images/menu-headphones.svg",
        plusScreen: "patient-audiometria-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
      {
        id: "patient-audifonos",
        screenToShow: "patient-datos",
        text: "Audífonos",
        icon: "../../images/menu-audifonos.svg",
        plusScreen: "patient-audifonos-nuevo",
        showInMenu: true,
        markInMenu: false,
      },
    ],
  },
  {
    id: "agenda",
    screenToShow: "agenda",
    text: "Agenda",
    icon: "../../images/menu-calendar-blue.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [],
  },
  {
    id: "ventas",
    screenToShow: "ventas",
    text: "TPV",
    icon: "../../images/menu-bill-blue.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [
      {
        id: "venta",
        screenToShow: "venta",
        text: "Ventas",
        icon: "../../images/delivery-note-white.svg",
        showInMenu: false,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "encargo",
        screenToShow: "encargo",
        text: "Encargos",
        icon: "../../images/delivery-note-white.svg",
        showInMenu: false,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "presupuesto",
        screenToShow: "presupuesto",
        text: "Presupuestos",
        icon: "../../images/delivery-note-white.svg",
        showInMenu: false,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "proforma",
        screenToShow: "proforma",
        text: "Proformas",
        icon: "../../images/delivery-note-white.svg",
        showInMenu: false,
        markInMenu: true,
        subsections: [],
      },
    ],
  },
  {
    id: "almacen",
    screenToShow: "",
    text: "Almacén",
    icon: "../../images/menu-box-blue.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [
      {
        id: "almacen-albaran",
        screenToShow: "almacen-albaran",
        text: "Albaranes",
        icon: "../../images/delivery-note-white.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "almacen-facturas",
        screenToShow: "almacen-facturas",
        text: "Facturas",
        icon: "../../images/invoice-white.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "almacen-pedidos",
        screenToShow: "almacen-pedidos",
        text: "Pedidos",
        icon: "../../images/order-white.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "almacen-proveedores",
        screenToShow: "almacen-proveedores",
        text: "Proveedores",
        icon: "../../images/supplier-white.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
    ],
  },
  {
    id: "crm",
    screenToShow: "crm",
    text: "CRM",
    icon: "../../images/menu-crm-blue.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [],
  },
  {
    id: "dashboard",
    screenToShow: "",
    text: "Dashboard",
    icon: "../../images/menu-shop-blue.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [
      {
        id: "dashboard-ventas",
        screenToShow: "dashboard-ventas",
        text: "Ventas",
        icon: "../../images/menu-bill-blue.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "dashboard-almacen",
        screenToShow: "dashboard-almacen",
        text: "Almacén",
        icon: "../../images/menu-box-blue.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "dashboard-pacientes",
        screenToShow: "dashboard-pacientes",
        text: "Pacientes",
        icon: "../../images/patient-icon.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
    ],
  },
  {
    id: "gestion-documental",
    screenToShow: "gestion-documental",
    text: "Gestión documental",
    icon: "../../images/menu-doc-blue.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [],
  },
  {
    id: "control-laboral",
    screenToShow: "control-laboral",
    text: "Control laboral",
    icon: "../../images/support-extra/horas-laborales-white.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [],
  },
  {
    id: "configuracion",
    screenToShow: "configuracion",
    text: "Configuración",
    icon: "../../images/home-icon.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [],
  },
  {
    id: "debug",
    screenToShow: "debug-textfields", // Screen to show when selected
    text: "Debug",
    icon: "../../images/menu-bug.svg",
    showInMenu: true,
    markInMenu: true,
    subsections: [
      {
        id: "debug-textfields",
        screenToShow: "debug-textfields",
        text: "Textfields",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-exports",
        screenToShow: "debug-exports",
        text: "Exports",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-skeleton",
        screenToShow: "debug-skeleton",
        text: "Skeleton",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-cash-popup",
        screenToShow: "debug-cash-popup",
        text: "Cash popup",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-reports",
        screenToShow: "debug-reports",
        text: "Informes",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-online-orders",
        screenToShow: "debug-online-orders",
        text: "Pedidos",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-wacom-signature",
        screenToShow: "debug-wacom-signature",
        text: "Firma WACOM",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
      {
        id: "debug-godex-printing",
        screenToShow: "debug-godex-printing",
        text: "Impresión GoDEX",
        icon: "../../images/menu-bug.svg",
        showInMenu: true,
        markInMenu: true,
        subsections: [],
      },
    ],
  },
];
